// Region Globe functionality
class RegionGlobe {
  constructor() {
    this.globe = null;
    this.region = null;
    this.init();
  }

  init() {
    if (typeof window.aianta === "undefined") {
      window.aianta = {};
    }
    window.aianta.globestuff = this.setupGlobeStuff.bind(this);
  }

  setupGlobeStuff() {
    const globeData = $(".map-points");
    if (!globeData.length) return;

    this.region = this.getRegionData();
    $("#map-loading-spinner").hide();

    if (window.aianta && window.aianta.useWebGL === true) {
      this.globe = this.setupGlobe();
      this.globe.setupRegion(this.region);
      $("#globefallback").hide();
    } else {
      $("#ViewContainer").hide();
      $("#globefallback").show();
    }

    const approved = this.approvedGeolocation();
    if (approved === "yes") {
      this.findRoute();
    } else if (this.globe) {
      this.globe.createGoToLocation(
        this.region.regionPoint.lat,
        this.region.regionPoint.lon
      );
    }

    this.bindEvents();
  }

  bindEvents() {
    $("#find-route")
      .off("click")
      .on("click", () => {
        this.findRoute();
      });

    $("#no-thanks")
      .off("click")
      .on("click", () => {
        this.hideBox();
        if (this.globe) {
          this.globe.oneSpin();
        }
      });
  }

  getRegionData() {
    const globeData = $(".map-points");
    const regionData = {};
    regionData.regionSize = [];
    regionData.regionPoint = {};

    const regionImgPath = globeData.data("image");
    const regionImg = new Image();
    regionImg.crossOrigin = "anonymous";
    regionImg.src = regionImgPath;
    regionData.regionImg = regionImg;

    const regionSizeString = globeData.data("size").split(" ");
    regionSizeString.forEach((value) => {
      regionData.regionSize.push(parseInt(value, 10));
    });

    regionData.regionPoint.lat = globeData.data("lat");
    regionData.regionPoint.lon = globeData.data("lon");

    return regionData;
  }

  setupGlobe() {
    try {
      const windowWidth = $(window).width();
      const globeDiv = $(".l-three-col-left");

      if (!globeDiv.length) {
        console.warn("Globe container (.l-three-col-left) not found");
        return null;
      }

      const widthHeight = globeDiv.width() * 0.9;

      const options = {
        width: widthHeight,
        height: widthHeight,
        globeBackColor: "#73514F55",
        globeFrontColor: "#BBBBBBBB",
        globeLinesColor: "#00000000",
        rotationIdleSpeedFactor: 10.0,
        rotationSpeedFactor: 1.5,
        wave: false,
      };

      const canvas = document.getElementById("3DView");
      if (!canvas) {
        console.warn("3D View canvas not found");
        return null;
      }

      if (!window.Globe) {
        console.warn("Globe class not available");
        return null;
      }

      const globe = new window.Globe(canvas, options);
      globe.loadingSpinner = $("#map-loading-spinner");

      const globeData = $(".map-points");
      if (globeData.length) {
        globe.youreHereImage = globeData.data("dot-image");
        globe.dotImage = globeData.data("dot-image");
      }

      return globe;
    } catch (error) {
      console.error("Error setting up globe:", error);
      return null;
    }
  }

  findRoute() {
    this.hideActions();
    this.getLocation();
  }

  showActions() {
    $(".globe-action").show();
  }

  hideActions() {
    $(".globe-action").hide();
  }

  hideBox() {
    $(".globe-floating-box").hide();
  }

  approvedGeolocation() {
    const name = "uselocation=";
    const ca = document.cookie.split(";");

    for (let i = 0; i < ca.length; i++) {
      if (ca[i].trim() === "uselocation=yes") {
        return "yes";
      }
    }
    return "no";
  }

  getLocation() {
    if (navigator.geolocation) {
      document.cookie = "uselocation=yes";
      if (this.globe) {
        this.globe.startLoadingSpinner();
      }
      $(".globe-distance-message").addClass("is-open");
      $("#my-distance").text("Calculating Travel Time...");

      navigator.geolocation.getCurrentPosition(
        this.showPosition.bind(this),
        this.errorPosition.bind(this),
        { timeout: 30000 }
      );
    } else {
      alert("Geolocation is not supported by this browser.");
    }
  }

  errorPosition() {
    $("#my-distance").text("Geolocation or browser issues");
    if (this.globe) {
      this.globe.stopLoadingSpinner();
    }
  }

  showPosition(position) {
    const globeMath = new window.GlobeMath();
    const myPoint = {
      lat: position.coords.latitude,
      lon: position.coords.longitude,
    };

    if (this.globe) {
      this.globe.createGoToLocation(myPoint.lat, myPoint.lon);
      this.globe.myPoint = myPoint;
      this.globe.regionPoint = this.region.regionPoint;
      this.globe.animateUser();
    }

    const distance = globeMath.getDistanceFromLatLonInKm(
      myPoint,
      this.region.regionPoint
    );
    const time = globeMath.distanceToTime(distance);
    this.setDistanceMessage(time);

    if (this.globe && time > 1) {
      this.globe.animateTravel();
    }

    this.hideBox();
  }

  setDistanceMessage(time) {
    const hour = time < 2 ? " hour" : " hours";
    $("#my-distance").text(time + hour);
    $("#distance-message").text("travel time by air");
  }
}

// Initialize on page load
document.addEventListener("turbolinks:load", () => {
  // Only initialize if we have the necessary elements
  try {
    const hasMapPoints = document.querySelector(".map-points");
    const has3DView = document.getElementById("3DView"); // Use getElementById instead

    if (hasMapPoints || has3DView) {
      const regionGlobe = new RegionGlobe();

      // Make it globally accessible if needed
      window.regionGlobe = regionGlobe;

      // Call the setup function
      if (window.aianta && window.aianta.globestuff) {
        window.aianta.globestuff();
      }
    }
  } catch (error) {
    console.warn("RegionGlobe initialization skipped:", error.message);
  }
});

export default RegionGlobe;
